import { flexCenter } from '@anm/styles/helpers';
import Button from '@anm/components/buttons/Button';
import { landingCTAVariants } from '@anm/styles/landingThemeStyles';
import styled, { css } from 'styled-components';
export var LandingCTAWrapper = styled.div.withConfig({
  componentId: "sc-1dv2wf0-0"
})(["margin:32px auto 0;", ""], function (_ref) {
  var isCentered = _ref.isCentered;
  return isCentered && css(["", ";"], flexCenter);
});
export var CTAButton = styled(Button).withConfig({
  componentId: "sc-1dv2wf0-1"
})(["transition:0.3s;padding:14px 20px;max-width:100%;overflow:hidden;text-overflow:ellipsis;height:unset;line-height:unset;color:#fff;background:transparent;border-radius:0;min-width:140px;", ";", ""], function (_ref2) {
  var fontStyles = _ref2.fontStyles;
  return fontStyles && "".concat(fontStyles);
}, function (_ref3) {
  var buttonTheme = _ref3.buttonTheme;
  return landingCTAVariants[buttonTheme];
});